module.exports = __webpack_public_path__ + "static/media/location.f62f1cb8.svg";